/**
 * Documentos da empresa (PJ) solicitados no fluxo Badesul, espelhando o app.
 * Fonte: app/src/screens/BusinessBadesulPronampeRegisterScreen/utils.js — o
 * BadesulPronampeBusinessFileStep é o step usado tanto pelo MPE quanto pelo
 * Microcrédito (BusinessBadesulMicrocreditoRegisterScreen importa esse step e
 * ramifica por isBadesulMpe === (portfolio.name === 'Badesul MPE')). (GYR-1489)
 *
 * `bylaws` (contratual) e `proofOfAddress` (endereço) são sempre pedidos e
 * persistidos via saveBusiness, então NÃO entram aqui. Os documentos abaixo são
 * adicionais: lidos de business.additionalFiles por parent.name === documentValue
 * e persistidos via addAdditionalFile. Muitos vêm pré-preenchidos quando a
 * integração/BigData já os trouxe.
 */

// Compartilhados por MPE e Microcrédito (_documentList do app).
const sharedDocuments = [
  {
    documentValue: 'cartaoCNPJ',
    label: 'Cartão CNPJ',
  },
  {
    documentValue: 'qsa',
    label: 'QSA',
    alertMessage: 'Quadro de sócios e administradores',
  },
  {
    documentValue: 'cadinEstadual',
    label: 'CADIN Estadual',
    alertMessage: 'Comprovação de que a empresa está em dia com o CADIN Estadual',
  },
  {
    documentValue: 'cadin',
    label: 'CADIN Federal',
    alertMessage:
      'Comprovação de que a empresa está em dia com o Cadastro Informativo de Créditos não Quitados do Setor Público Federal',
  },
  {
    documentValue: 'stateCnd',
    label: 'CND Estadual',
    alertMessage: 'Comprovação de que a empresa está em dia com o estado do Rio Grande do Sul',
  },
  {
    documentValue: 'pgfn',
    label: 'PGFN',
    alertMessage:
      'Comprovação de que a empresa está em dia com a Procuradoria-Geral da Fazenda Nacional',
  },
  {
    documentValue: 'cndTrabalhista',
    label: 'CND Trabalhista',
    alertMessage: 'Comprovação de que a empresa está em dia com os direitos trabalhistas',
  },
];

// Cauda específica do Microcrédito (badesulDocumentList do app).
const microcreditoDocuments = [
  ...sharedDocuments,
  {
    documentValue: 'fgts',
    label: 'FGTS ou Print do e-social',
    alertMessage: 'Caso seja optante do E-social',
  },
  {
    documentValue: 'raisPerson',
    label: 'RAIS',
  },
];

// Cauda específica do MPE (badesulMpeDocumentList do app).
const mpeDocuments = [
  ...sharedDocuments,
  {
    documentValue: 'fgts',
    label: 'FGTS',
  },
  {
    documentValue: 'eSocialPrint',
    label: 'Print do E-social',
  },
];

/**
 * Retorna a lista de documentos adicionais da empresa conforme o produto Badesul.
 * @param {string} portfolioName - loan.portfolioName ('Badesul MPE' | 'Badesul Microcrédito')
 */
const getBadesulBusinessDocuments = (portfolioName) => (
  portfolioName === 'Badesul MPE' ? mpeDocuments : microcreditoDocuments
);

export default getBadesulBusinessDocuments;
